/**
 * Created by dv on 7/10/2017.
 */
import { fetch } from 'whatwg-fetch';
import {
  CollectionFilters,
  LsCollectionSortCriteria,
  LsZmCollectionsMessage,
  LsZmCollectionsQuery,
  ValueList
} from '../../autogenerated/ZoomBridge';
import Authenticator from '../../protocol/Authenticator';
import { MINE } from '../../util/Constants';

import HashMap from './../../protocol/HashMap';
import CollectionUtil from './CollectionUtil';
export default class LsCollections {
  /**
   *
   *
   */
  constructor() {
    this._filterExpired = true;
    this._thumbImageCount = 4;
    this._pageLimit = CollectionUtil.PAGE_LIMIT;
    this._sortByParam = CollectionUtil.SORT_PARAMS.DEFAULT_SORT_CRITERIA;
    this._collectionId = -1;
    this._begIndex = 0;
    this._fetchFullList = false;
    this._onlyBins = true;
    this._onlyCollections = true;

    if (window.gs.collectionOwnerFilter === MINE) {
      this._owner = window.gs.isExternalUser ? Authenticator.AUTH_DATA.externalUserId : Authenticator.AUTH_DATA.username;
    }
    else {
      this._owner = null;
    }

    /**
     * @type {HashMap}
     * @private
     */
    this.filters = null;
    this._searchValues = [];
  }

  setNameSearchString(nameMatchString) {
    this.nameMatchString = nameMatchString;
    return this;
  }

  /**
   * Sets up paging parameters
   */

  setPageLimit(pageLimit) {
    this._pageLimit = pageLimit;
    return this;
  }

  setFetchFullList(fetchFullList) {
    this._fetchFullList = fetchFullList;
    return this;
  }

  setOnlyBins(onlyBins) {
    this._onlyBins = onlyBins;
    return this;
  }

  setOwner(bool) {
    this._owner = bool ? (window.gs.isExternalUser ? Authenticator.AUTH_DATA.externalUserId : Authenticator.AUTH_DATA.username) : null;
    return this;
  }

  setOnlyCollections(onlyCollections) {
    this._onlyCollections = onlyCollections;
    return this;
  }

  setThumbImageCount(thumbImageCount) {
    this._thumbImageCount = thumbImageCount >= 0 ? thumbImageCount : 4;
    return this;
  }

  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }

  /**
   * Select a value from the static constants present in LsCollectionSortBy class
   * @param sortByParam
   * @return {LsCollections}
   */
  setSortBy(sortByParam, sortOrder) {
    this._sortByParam = sortByParam;
    this._sortOrder = sortOrder;
    return this;
  }

  setBegIndex(begIndex) {
    this._begIndex = begIndex;
    return this;
  }

  /**
   *
   * @param {string} filterName
   * @param {Array} filterValues
   * @param {boolean} exactWordMatch
   */
  setCollectionFilters(filterName, filterValues, exactWordMatch = true) {
    if (!this.filters) {
      this.filters = new HashMap();
    }
    let valueList = this.filters.get(filterName);
    if (!valueList) {
      valueList = new ValueList();
    }
    let isDateFilter = filterName === CollectionUtil.CREATED_IN_KEY || filterName === CollectionUtil.MODIFIED_IN_KEY;

    if (!isDateFilter && exactWordMatch && filterValues && filterName !== CollectionUtil.COLLECTION_NAME_KEY
      && filterName !== CollectionUtil.COLLECTION_TYPE_KEY) {
      filterValues = filterValues.map(function (v) {
        if (v === CollectionUtil.COLLECTION_EXPIRED) {
          return v;
        }
        return `regex:^${v}$`;
      });
    }
    valueList.setValues(filterValues);
    this.filters.put(filterName, valueList);
  }

  resetFilters() {
    this.filters = null;
  }

  /**
   * Return the count of filters.
   * @public
   * @return {int}
   */
  getFiltersCount() {
    let count = 0;
    if (this.filters) {
      this.filters.forEach(function (key, value) {
        if (value && value.getValues()) {
          count = count + value.getValues().length;
        }
      });
    }
    return count;
  }

  /**
   * @return {Array<String>}
   */
  getSearchValues() {
    return this._searchValues;
  }

  /**
   * @param searchValues{Array<String>}
   * @return {LsZmCollectionsMessage}
   */
  setSearchValues(searchValues) {
    this._searchValues = searchValues;
    return this;
  }

  /**
   * resp{LsZmCollectionsResponse} of zmcollections will be used as input to onSuccess
   * @return {Promise}
   */
  run() {
    const query = new LsZmCollectionsQuery();
    const msg = new LsZmCollectionsMessage();
    msg.setBegIndex(this._begIndex);
    msg.setPageLimit(this._fetchFullList ? 0 : this._pageLimit);
    msg.setThumbImageCount(this._thumbImageCount);
    msg.setCollectionId(this._collectionId);
    msg.setFetchFullList(this._fetchFullList);
    msg.setOnlyBins(this._onlyBins);
    msg.setOnlyCollections(this._onlyCollections);

    if (this._owner) {
      if (!this.filters) {
        this.filters = new HashMap();
      }
      this.filters.put(CollectionUtil.OWNER_KEY, new ValueList().setValues([this._owner]));
    }
    msg.setCollectionFilters(new CollectionFilters().setFilters(this.filters));
    // msg.setFilterExpired(this._filterExpired);
    msg.setLsCollectionSortCriteria(
      new LsCollectionSortCriteria().setOrder(this._sortOrder).setSortBy(this._sortByParam)
    );
    //msg.setCollectionQueryParam(new CollectionQueryParam().setName(this.nameMatchString));
    msg.setSearchValues(this._searchValues);
    query.message = msg;
    return query.run(true);
  }
}
